import { render, staticRenderFns } from "./FormItemx.vue?vue&type=template&id=7a88c255&scoped=true&"
import script from "./FormItemx.vue?vue&type=script&lang=js&"
export * from "./FormItemx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a88c255",
  null
  
)

export default component.exports